import axios from 'axios';
import ReactGA from 'react-ga4';

const useFormSubmission = (authToken, scrollToBottom, handleSetMessage, setFormData, setShowFormQuote, setShowFormSupplier, setIsInputDisabled, setIsMenuDisabled) => {

  const submitForm = async (formData, enquiryType, apiUrl) => {
    ReactGA.event({
      category: 'Navigation',
      action: 'Form Submitted',
    });

    let formattedData;
    let headers = {
      'Content-Type': 'application/json',
    };
    formattedData = {
    referrer: "WEB_SITE",
    enquiryType: enquiryType,
    location: null,
    email: formData["Email Address"],
    company: formData["Company name"],
    organisationName: formData["Company name"],
    companyGST: formData["Company GST"],
    isBuyout: true,
    userId: null,
    mobile: formData["Phone number"],
    notes: formData["Product Name"],
    lineItems: [
        {
        title: formData["Product Name"],
        categoryName: formData["Product Name"],
        categoryId: null,
        quantity: parseInt(formData["Quantity"], 10),
        quantityUnit: formData["Unit of Measurement"],
        },
    ],
    source: null,
    campaign: null,
    medium: null,
    };

    // Supplier and Quotes headers
    headers = {
    ...headers,
    'x-ofb-token': authToken,
    };
    

    try {
      const response = await axios.post(apiUrl, formattedData, {
        headers: headers,
      });
      setFormData({});
      setShowFormQuote(false);
      setShowFormSupplier(false);
      setIsInputDisabled(false);
      setIsMenuDisabled(false);
        handleSetMessage(
          `Your enquiry with ID: ${response.data.data.enquiryId || 'N/A'} is under review.\n We will get back to you shortly!\nLet me know if you need more help`,
          "system"
        );
      
    } catch (error) {
      console.error("Error sending form data:", error);
      handleSetMessage("Failed to send form data. Please try again later.", "system");
      setShowFormQuote(false);
      setShowFormSupplier(false);
    } finally {
      setTimeout(() => {
        scrollToBottom();
      }, 100);
    }
  };

  return submitForm;
};

export default useFormSubmission;
